// extracted by mini-css-extract-plugin
export default {"box":"Box_box__IhjcJ","default":"Box_default__-0qMY","shade":"Box_shade__hOuIJ","light":"Box_light__IJ2-F","accent":"Box_accent__zMgG5"};